.deleteConfirmationList {
    color: var(--hps-blue);
}